module.exports = __webpack_public_path__ + "static/media/envdemo.4cf9ac0d.png";